import { render, staticRenderFns } from "./segmentRemarketingPopup.vue?vue&type=template&id=5c1dfa61&"
import script from "./segmentRemarketingPopup.vue?vue&type=script&lang=js&"
export * from "./segmentRemarketingPopup.vue?vue&type=script&lang=js&"
import style0 from "./segmentRemarketingPopup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports